import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { Switch, Table, Menu, Dropdown, Modal, notification } from "antd";
import DrawerPagina from "./_Aux/DrawerPagina";
import PaginaInformacoes from "./PaginaInformacoes";
import axios from "axios";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class Paginas extends Component {
    state = {
        paginas: [],
        paginasMobile: [],
        ativo: true,
        paginaId: "",
        ordem: 1,
        //LOADING
        loading_table: false,
        //DRAWER
        visible: false,
        //INFORMACOES
        paginaInformacoesVisivel: false
    };

    UNSAFE_componentWillMount() {
        this.listar();
    }

    handleChangeSwitch = ativo => {
        this.setState(
            {
                ativo
            },
            () => {
                this.listar();
            }
        );
    };

    //MONTA AS OPÇÕES DE MENU POR CADA CATEGORIA NA TABELA
    montarMenu = (paginaId, ativo) => {
        return (
            <Menu>
                <Menu.Item>
                    <Link to="#" onClick={() => this.editar(paginaId)}>
                        Editar
                    </Link>
                </Menu.Item>
                <Menu.Item>
                    <Link to="#" onClick={() => this.excluir(paginaId)}>
                        Excluir
                    </Link>
                </Menu.Item>
                <Menu.Item>
                    <Link to="#" onClick={() => this.ativar(paginaId, ativo)}>
                        {ativo ? "Inativar" : "Ativar"}
                    </Link>
                </Menu.Item>
                <Menu.Item>
                    <Link to="#" onClick={() => this.carregarArtigos(paginaId)}>
                        Artigos
                    </Link>
                </Menu.Item>
            </Menu>
        );
    };

    adicionar = () => {
        this.setState({
            paginaId: "",
            visible: true
        })
    }

    editar = paginaId => {
        this.setState({
            paginaId,
            visible: true
        })
    }

    excluir = paginaId => {
        confirm({
            title: "Pretende excluir esta página?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "delete",
                    url: "/api/empresa/excluir-pagina",
                    params: {
                        paginaId
                    }
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", "Página excluida!");
                        this.listar();
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", "Não é possível excluir este registo!");
                    });
            }
        });
    };

    ativar = (paginaId, ativo) => {
        confirm({
            title: ativo ? "Pretende inativar esta página?" : "Pretende ativar esta página?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "put",
                    url: "/api/empresa/ativar-pagina",
                    params: {
                        paginaId
                    }
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", ativo ? "Página inativada!" : "Página ativada!");
                        this.listar();
                    })
                    .catch(error => {
                        openNotificationWithIcon(
                            "error",
                            "Erro",
                            ativo ? "Não foi possível inativar a página!" : "Não foi possível ativar a página!"
                        );
                    });
            }
        });
    };

    carregarArtigos = (paginaId) => {
        this.setState({
            paginaId,
            paginaInformacoesVisivel: true
        })
    }

    voltar = () => {
        this.setState({
            paginaId: "",
            paginaInformacoesVisivel: false
        })
    }

    listar = () => {
        this.setState(
            {
                loading_table: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/empresa/listar-paginas",
                    params: {
                        ativo: this.state.ativo
                    }
                })
                    .then(response => {
                        var paginas = [];
                        var paginasMobile = [];

                        response.data.map((pagina, index) => {
                            paginas.push({
                                key: index,
                                id: pagina.id,
                                pagina: pagina.titulo,
                                ordem: pagina.ordem,
                                opcoes: (
                                    <Dropdown overlay={this.montarMenu(pagina.id, pagina.ativo)} placement="bottomLeft">
                                        <Link to="#" className="botao-icon-configs">
                                            <i className="fas fa-cog" />
                                        </Link>
                                    </Dropdown>
                                )
                            });
                            paginasMobile.push({
                                key: index,
                                id: pagina.id,
                                pagina: <div className="bloco-pagina">
                                    <div className="info-pagina">
                                        <span className="titulo-pagina">{pagina.titulo}</span>
                                        <span className="ordem-pagina"><strong>Ordem:</strong> {pagina.ordem}</span>
                                    </div>
                                </div>,
                                ordem: pagina.ordem,
                                opcoes: (
                                    <Dropdown overlay={this.montarMenu(pagina.id, pagina.ativo)} placement="bottomLeft">
                                        <Link to="#" className="botao-icon-configs">
                                            <i className="fas fa-cog" />
                                        </Link>
                                    </Dropdown>
                                )
                            });
                        });

                        this.setState({
                            paginas,
                            paginasMobile,
                            ordem: (response.data.length + 1),
                            loading_table: false
                        });
                    })
                    .catch(error => {
                        if (error.response.status === 401)
                            this.setState({
                                redirect: true,
                                redirectLink: "/login"
                            });
                    });
            }
        );
    };

    atualizarRegisto = () => {
        this.setState({
            visible: false
        })
        this.listar();
    }

    render() {
        const {
            paginas,
            paginasMobile,
            paginaId,
            ordem,
            //LOADING
            loading_table,
            //DRAWER
            visible,
            //INFORMACOES
            paginaInformacoesVisivel
        } = this.state;

        const columns = [
            {
                title: "Página",
                dataIndex: "pagina"
            },
            {
                title: "Ordem",
                dataIndex: "ordem",
                width: 100
            },
            {
                title: "",
                dataIndex: "opcoes",
                width: 10
            }
        ];

        const columnsMobile = [
            {
                title: "Página",
                dataIndex: "pagina"
            },
            {
                title: "",
                dataIndex: "opcoes",
                width: 10
            }
        ];

        return (
            <>
                {!paginaInformacoesVisivel ?
                    <div className="bloco-minha-conta">
                        <div className="bloco-gestor-paginas">
                            <div className="controlos">
                                <button className="botao-principal" onClick={this.adicionar}>
                                    Adicionar
                            </button>
                                <Switch
                                    checkedChildren="Ativos"
                                    unCheckedChildren="Inativos"
                                    defaultChecked
                                    onChange={this.handleChangeSwitch}
                                />
                            </div>
                            <div className="bloco-tabela">
                                <Table
                                    id="tabela_categorias"
                                    className="tabela-paginas-desktop"
                                    loading={{
                                        spinning: loading_table,
                                        indicator: (
                                            <div className="loading-data-table">
                                                <div className="loading" />
                                            </div>
                                        )
                                    }}
                                    columns={columns}
                                    dataSource={paginas}
                                    pagination={false}
                                    locale={{ emptyText: "Não existem registos!" }}
                                />
                                <Table
                                    id="tabela_categorias"
                                    className="tabela-paginas-mobile"
                                    loading={{
                                        spinning: loading_table,
                                        indicator: (
                                            <div className="loading-data-table">
                                                <div className="loading" />
                                            </div>
                                        )
                                    }}
                                    columns={columnsMobile}
                                    dataSource={paginasMobile}
                                    pagination={false}
                                    locale={{ emptyText: "Não existem registos!" }}
                                />
                            </div>
                        </div>
                        <DrawerPagina
                            paginaId={paginaId}
                            ordem={ordem}
                            visible={visible}
                            onClose={() => this.setState({ visible: false })}
                            atualizarRegisto={this.atualizarRegisto}
                        />
                    </div>
                    :
                    <PaginaInformacoes
                        paginaId={paginaId}
                        voltar={this.voltar}
                    />
                }
            </>
        );
    }
}

export default Paginas;
